import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'

import TCItem from '~/components/Footer/TCItem'
import { useAppDispatch } from '~/redux/hooks'
import { setShowCookieConsentBanner } from '~/redux/slices/user'

export default function TermsAndConditions(): React.ReactElement {
  const { t } = useTranslation('footer')
  const dispatch = useAppDispatch()
  let interval: NodeJS.Timeout | null = null

  useEffect(() => {
    // Cleanup interval on component unmount
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickCookie = (): void => {
    dispatch(setShowCookieConsentBanner(true))
    // the dispatch will initiate the CookieConsent script if it is not already loaded before calling renew
    if (typeof window !== 'undefined' && window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
      window.CookieConsent.renew()
    } else if (!interval) {
      interval = setInterval(() => {
        if (typeof window !== 'undefined' && window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
          window.CookieConsent.renew()
          clearInterval(interval as NodeJS.Timeout)
          interval = null
        }
      }, 500)
    }
  }

  return (
    <div className="flex justify-center items-center space-x-8">
      <TCItem label={t('terms')} to="/terms-and-conditions" />
      <TCItem label={t('privacy')} to="/privacy" />
      {/* <TCItem label={t('cookies')} to="/cookie-policy" /> */}
      <TCItem label={t('cookies')} onClick={onClickCookie} />
    </div>
  )
}
